import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stage" }
const _hoisted_2 = { class: "stage-inner" }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "contact" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = {
  class: "contact-item",
  href: "mailto:info@rainbow-manager.com"
}
const _hoisted_8 = { class: "description" }
const _hoisted_9 = {
  class: "contact-item",
  href: "mailto:support@rainbow-manager.com"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"blobs\" aria-hidden=\"true\" data-v-647d53f0><span class=\"blob b1\" data-v-647d53f0></span><span class=\"blob b2\" data-v-647d53f0></span><span class=\"blob b3\" data-v-647d53f0></span><span class=\"blob b4\" data-v-647d53f0></span></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "kicker" }, "Rainbow Manager", -1)),
      _createElementVNode("h1", null, _toDisplayString(_ctx.t('contacts')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('contactsLead')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("section", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('ideaAndSuggestions')), 1),
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'envelope'] }),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "info@rainbow-manager.com", -1))
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('supportAndAssistance')), 1),
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'envelope'] }),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "support@rainbow-manager.com", -1))
          ])
        ])
      ])
    ])
  ]))
}